const _ = require('lib/underscore')
const alertDialog = require('./dialog_alert')

const log = require('log').create('dialog', 'error'); // eslint-disable-line


function errorDialog(html, options = {}) {

    _.defaults(options, {
        title: 'It’s not you, it’s us',
    })

    return alertDialog(html, options)
}

module.exports = errorDialog
